"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _zod = require("zod");

var _dateRelative = _interopRequireDefault(require("../../libs/translationsUtils/dateRelative"));

var _EventDateFormatter = _interopRequireDefault(require("../Event/EventDateFormatter"));

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var widgetName = 'topic_banner';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-topic_banner';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  selectedTopic: _zod.z.custom(),
  textColor: _zod.z.string().nullable()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var TopicBanner = function TopicBanner(_ref) {
  var _selectedTopic$author, _selectedTopic$post, _selectedTopic$publis, _selectedTopic$post2;

  var config = _ref.config;
  var selectedTopic = config.selectedTopic,
      backgroundColor = config.backgroundColor,
      textColor = config.textColor,
      backgroundColorDisplay = config.backgroundColorDisplay;

  if (!selectedTopic) {
    return null;
  }

  var author = (_selectedTopic$author = selectedTopic.author) !== null && _selectedTopic$author !== void 0 ? _selectedTopic$author : (_selectedTopic$post = selectedTopic.post) === null || _selectedTopic$post === void 0 ? void 0 : _selectedTopic$post.author;
  var date = (_selectedTopic$publis = selectedTopic.publishedAt) !== null && _selectedTopic$publis !== void 0 ? _selectedTopic$publis : selectedTopic.createdAt;
  return (0, _preact.h)(_widgetContainer.default, {
    widgetName: widgetName,
    config: config
  }, (0, _preact.h)("div", {
    className: "topic-banner_wrapper featuredBanner"
  }, (0, _preact.h)("a", {
    className: "banner-notification_url",
    "aria-labelledby": "banner-data",
    href: (0, _absoluteUrlRuntime.resolveUrl)(selectedTopic.url)
  }), (0, _preact.h)("div", {
    id: "banner-data",
    className: (0, _classnames.default)('box', 'banner-notification', 'notification', {
      notification_custom: !!backgroundColorDisplay || !!backgroundColor
    })
  }, (0, _preact.h)("div", {
    className: "box__content box__pad"
  }, (0, _preact.h)("p", {
    className: "notification-title"
  }, (0, _preact.h)("span", {
    style: {
      color: textColor !== null && textColor !== void 0 ? textColor : undefined
    },
    className: "notification-link"
  }, selectedTopic.title.length > 100 ? selectedTopic.title.substring(0, 100) + '...' : selectedTopic.title)), selectedTopic.startsAt ? (0, _preact.h)("span", {
    style: {
      color: textColor !== null && textColor !== void 0 ? textColor : undefined
    },
    className: "thread-meta-item__date notification-link"
  }, "(", _EventDateFormatter.default.formatStartAtForOverviewList(selectedTopic.startsAt), ")") : (0, _preact.h)("span", {
    className: "thread-meta-item"
  }, author !== undefined && (0, _preact.h)(_UserAvatar.default, {
    user: author,
    extraClass: "avatar avatar--S",
    showRank: true
  }), (0, _preact.h)("span", {
    className: "notification-link"
  }, (0, _preact.h)("span", {
    style: {
      color: textColor !== null && textColor !== void 0 ? textColor : undefined
    },
    className: "thread-meta-item__date"
  }, date ? (0, _preact.h)(_dateRelative.default, {
    dateTime: new Date(date).getTime()
  }) : ((_selectedTopic$post2 = selectedTopic.post) === null || _selectedTopic$post2 === void 0 ? void 0 : _selectedTopic$post2.relativeCreationDate) || '')))))));
};

var _default = TopicBanner;
exports.default = _default;